import React from 'react';

import { prerenderHooks } from '@nxte-nl/prerender-hooks';
import { stateHooks } from '@nxte-nl/state-hooks';

import { pageStateHooks } from '../../hooks/pageStateHooks/pageStateHooks';
import { PrerenderingOptions } from '../../types/Prerendering';

export type Props = PrerenderingOptions & { timeoutMs?: number };
export const PrerenderContainer = React.memo((props: Props) => {
  let prerenderingReady = pageStateHooks.usePageReady(props);
  if (props.timeoutMs) {
    prerenderingReady = stateHooks.useTimeoutExpired(prerenderingReady, props.timeoutMs);
  }
  prerenderHooks.usePrerenderReady(prerenderingReady);
  return null;
});

PrerenderContainer.displayName = 'PrerenderContainer';
